import {AuthModel} from './_models'

const AUTH_LOCAL_STORAGE_KEY = 'kt-auth-react-v'
export const AUTH_SESSION_EXPIRED_KEY = 'auth:sessionExpired'

const getAuth = (): AuthModel | undefined => {
  if (!localStorage) {
    return
  }

  const lsValue: string | null = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY)
  if (!lsValue) {
    return
  }

  try {
    const auth: AuthModel = JSON.parse(lsValue) as AuthModel
    if (auth) {
      return auth
    }
  } catch (error) {
    console.error('AUTH LOCAL STORAGE PARSE ERROR', error)
  }
}

const setAuth = (auth: AuthModel) => {
  if (!localStorage) {
    return
  }

  try {
    const lsValue = JSON.stringify(auth)
    localStorage.setItem(AUTH_LOCAL_STORAGE_KEY, lsValue)
  } catch (error) {
    console.error('AUTH LOCAL STORAGE SAVE ERROR', error)
  }
}

const removeAuth = () => {
  if (!localStorage) {
    return
  }

  try {
    localStorage.removeItem(AUTH_LOCAL_STORAGE_KEY)
  } catch (error) {
    console.error('AUTH LOCAL STORAGE REMOVE ERROR', error)
  }
}

export function isSessionExpiredError(error: any): boolean {
  const message = String(error?.response?.data?.message ?? '')
  return error?.response?.status === 401 && message.toLowerCase().includes('sessão expirou')
}

export function isAuthError(error: any): boolean {
  const status = error?.response?.status
  return status === 401 || status === 403
}

export function markSessionExpired() {
  try {
    sessionStorage.setItem(AUTH_SESSION_EXPIRED_KEY, '1')
  } catch (error) {
    console.error('AUTH SESSION EXPIRED FLAG ERROR', error)
  }
}

export function consumeSessionExpiredFlag(): boolean {
  try {
    const expired = sessionStorage.getItem(AUTH_SESSION_EXPIRED_KEY) === '1'
    if (expired) {
      sessionStorage.removeItem(AUTH_SESSION_EXPIRED_KEY)
    }
    return expired
  } catch (error) {
    console.error('AUTH SESSION EXPIRED FLAG ERROR', error)
    return false
  }
}

function redirectToLoginIfNeeded() {
  const base = process.env.PUBLIC_URL || ''
  if (!window.location.pathname.includes('/auth')) {
    window.location.href = `${base}/auth/login`
  }
}

export function handleSessionExpired() {
  markSessionExpired()
  removeAuth()
  document.dispatchEvent(new Event('user:logout'))
  redirectToLoginIfNeeded()
}

function attachResponseInterceptor(axiosInstance: any) {
  axiosInstance.interceptors.response.use(
    (response: any) => response,
    (error: any) => {
      if (isSessionExpiredError(error)) {
        handleSessionExpired()
      }
      return Promise.reject(error)
    }
  )
}

export function setupAxios(axios: any) {
  axios.defaults.headers.Accept = 'application/json'
  axios.interceptors.request.use(
    (config: {headers: {Authorization: string}}) => {
      const auth = getAuth()
      if (auth && auth.api_token) {
        config.headers.Authorization = `Bearer ${auth.api_token}`
      }

      return config
    },
    (err: any) => Promise.reject(err)
  )
  attachResponseInterceptor(axios)
}

export {getAuth, setAuth, removeAuth, AUTH_LOCAL_STORAGE_KEY, attachResponseInterceptor}
